import { CONTACT_POINT, DEVICE_TYPE, MEASUREMENT_TYPE, VITAL_TYPE } from 'types/entities'

import { ReactComponent as BloodPressuareIcon } from 'assets/images/blood-pressure-gauge.svg'
import { ReactComponent as OximeterIcon } from 'assets/images/pulse-oximeter.svg'
import { ReactComponent as Scale } from 'assets/images/ic-scale.svg'
import { ReactComponent as GlucoseIcon } from 'assets/images/glucose.svg'
import { ReactComponent as TermometrIcon } from 'assets/images/ic-temperature.svg'

export const DEVICE_NAMES_BY_TYPE = {
	[DEVICE_TYPE.DEVICE_BP]: 'Blood pressure',
	[DEVICE_TYPE.DEVICE_BP_CELLULAR]: 'Blood pressure',
	[DEVICE_TYPE.DEVICE_GL]: 'Glucose',
	[DEVICE_TYPE.DEVICE_GL_CELLULAR]: 'Glucose',
	[DEVICE_TYPE.DEVICE_PO]: 'Oximeter',
	[DEVICE_TYPE.DEVICE_PO_CELLULAR]: 'Oximeter',
	[DEVICE_TYPE.DEVICE_SC]: 'Scale',
	[DEVICE_TYPE.DEVICE_SC_CELLULAR]: 'Scale',
	[DEVICE_TYPE.DEVICE_T]: 'Temperature',
	[DEVICE_TYPE.DEVICE_T_CELLULAR]: 'Temperature',
}

export const VITAL_TYPE_BY_DEVICE_TYPE = {
	[DEVICE_TYPE.DEVICE_BP]: VITAL_TYPE.BLOOD_PRESSURE,
	[DEVICE_TYPE.DEVICE_BP_CELLULAR]: VITAL_TYPE.BLOOD_PRESSURE,
	[DEVICE_TYPE.DEVICE_GL]: VITAL_TYPE.GLUCOSE,
	[DEVICE_TYPE.DEVICE_GL_CELLULAR]: VITAL_TYPE.GLUCOSE,
	[DEVICE_TYPE.DEVICE_PO]: VITAL_TYPE.OXYGEN_SATURATION,
	[DEVICE_TYPE.DEVICE_PO_CELLULAR]: VITAL_TYPE.OXYGEN_SATURATION,
	[DEVICE_TYPE.DEVICE_SC]: VITAL_TYPE.WEIGHT,
	[DEVICE_TYPE.DEVICE_SC_CELLULAR]: VITAL_TYPE.WEIGHT,
	[DEVICE_TYPE.DEVICE_T]: VITAL_TYPE.TEMPERATURE,
	[DEVICE_TYPE.DEVICE_T_CELLULAR]: VITAL_TYPE.TEMPERATURE,
}

export const DEVICE_TYPE_IMAGES = {
	[DEVICE_TYPE.DEVICE_BP]: <BloodPressuareIcon className="w-[16px] " />,
	[DEVICE_TYPE.DEVICE_BP_CELLULAR]: <BloodPressuareIcon className="w-[20px] " />,
	[DEVICE_TYPE.DEVICE_GL]: <GlucoseIcon className="w-[20px] " />,
	[DEVICE_TYPE.DEVICE_GL_CELLULAR]: <GlucoseIcon className="w-[20px] " />,
	[DEVICE_TYPE.DEVICE_PO]: <OximeterIcon className="w-[20px] " />,
	[DEVICE_TYPE.DEVICE_PO_CELLULAR]: <OximeterIcon className="w-[20px] " />,
	[DEVICE_TYPE.DEVICE_SC]: <Scale className="w-[16px]" />,
	[DEVICE_TYPE.DEVICE_SC_CELLULAR]: <Scale className="w-[20px] " />,
	[DEVICE_TYPE.DEVICE_T]: <TermometrIcon className="w-[20px] " />,
	[DEVICE_TYPE.DEVICE_T_CELLULAR]: <TermometrIcon className="w-[20px]" />,
}

export const VITAL_TYPE_IMAGES = {
	[VITAL_TYPE.BLOOD_PRESSURE]: <BloodPressuareIcon className="w-[16px] " />,
	[VITAL_TYPE.GLUCOSE]: <GlucoseIcon className="w-[20px] " />,
	[VITAL_TYPE.OXYGEN_SATURATION]: <OximeterIcon className="w-[20px] " />,
	[VITAL_TYPE.WEIGHT]: <Scale className="w-[16px]" />,
	[VITAL_TYPE.TEMPERATURE]: <TermometrIcon className="w-[20px] " />,
}

export const MEASUREMENT_TYPE_TITLES = {
	[MEASUREMENT_TYPE.BODY_SCALE]: 'Weight, lb:',
	[MEASUREMENT_TYPE.BLOOD_GLUCOSE_BG]: 'Level:',
	[MEASUREMENT_TYPE.BLOOD_PRESSURE_DIA]: 'Diastolic:',
	[MEASUREMENT_TYPE.BLOOD_PRESSURE_SYS]: 'Systolic:',
	[MEASUREMENT_TYPE.BLOOD_PRESSURE_HB]: 'Pulse:',
	[MEASUREMENT_TYPE.THERMOMETER_C]: 'Temp, F:',
	[MEASUREMENT_TYPE.PULSE_OXIMETER_O]: 'Pressure, bpm:',
}

export const VITAL_TYPE_TITLES = {
	[VITAL_TYPE.BLOOD_PRESSURE]: 'Blood Pressure',
	[VITAL_TYPE.GLUCOSE]: 'Glucose',
	[VITAL_TYPE.OXYGEN_SATURATION]: 'Pulse Oximeter',
	[VITAL_TYPE.WEIGHT]: 'Scale',
	[VITAL_TYPE.TEMPERATURE]: 'Temperature',
}

export const IS_ACTIVE_OPTIONS = [
	{ value: 'isActive', label: 'Active' },
	{ value: 'isInactive', label: 'Inactive' },
]
export const IS_WISE_WOMAN_OPTIONS = [
	{ value: true, label: 'Is wisewoman' },
	{ value: false, label: 'Is not wisewoman' },
]

export const CONTACT_POINT_TYPES_OPTIONS: {
	label: string
	value: CONTACT_POINT
}[] = [
	{ label: 'Phone', value: CONTACT_POINT.PHONE },
	{ label: 'Email', value: CONTACT_POINT.EMAIL },
	{ label: 'Fax', value: CONTACT_POINT.FAX },
]

export enum FIELD_NAMES {
	POSTAL_CODE = 'postalCode',
	CITY = 'city',
	STATE = 'state',
	ACTIVE = 'active',
	TIMEZONE = 'timezone',
	MESSAGE = 'MESSAGE',
}

export enum MEMBER_CURRENT_URL {
	MEMBER_PROFILE = 'member-profile',
	SESSION_VIEW = 'session-view',
}

export enum AUTH_ERRORS {
	UNAUTHORIZED = 'Unauthorized',
	PERMISSION_DENIED = 'Permission denied',
}

// SCREEN WRAPPER CONTENT AND TITLE CLASSNAME
export enum SCREEN_WRAPPER_CONTENT {
	CONTENT_CLASSNAME = 'bg-fountainBlue',
	CONTENT_TITLE = 'border-b-fountainBlue',
}

// Common Classess used
export enum COMMON_FIELD_CLASSNAME {
	THREE_WIDTH_COLUMN = 'w-1/3 p-2',
	FULL_WIDTH_COLUMN = 'w-full p-2',
	MARGIN_TOP_TWO = 'mt-2',
	FIELD_WRAAPER = 'w-1/2 p-2',
	FORM_TABLE_SCROLL = 'content-height scrollbar-thin scrollbar-thumb-fountainBlue scrollbar-track-gray-200 overflow-y-auto pr-4 sm:pr-8 sm:pl-5 pl-2',
}
// Sections used
export enum SECTION_NAME {
	FILTER = 'filter',
	GLOBAL_FILTER = 'globalfilter',
	GRID = 'grid',
	GLOBAL_GRID = 'globalgrid',
	TILES = 'dsmesdashboardtiles',
	NUMBERS_ENROLLED = 'numbersenrolled',
	BILLABLE_SESSIONS = 'billablesessions',
	TOTAL_SESSIONS_COMPLETED = 'totalsessionscompleted',
	SESSIONS_COMPLETED = 'sessionscompleted',
	RETENTION_RATES = 'retentionratebysessions',
	// Provider
	ADD_PROVIDER = 'addprovider',
	PROVIDER_PROGRAMS = 'providerprograms',
	PROFILE = 'profile',
	//Conference
	CONFERENCE_DETAILS = 'conferencedetail',
	GLOBAL_CONFERENCE_DETAILS = 'globalconferencedetail',

	DESCRIPTION = 'description',
	GLOBAL_CONFERENCE_PROFILE = 'globalconferenceprofile',
	CONFERENCE_PROFILE = 'conferenceprofile',

	// Partner
	ADD_PARTNER = 'addpartner',
	PARTNER_PROFILE = 'partnerprofile',
	// Program
	ADD_PROGRAM = 'addprogram',
	PROGRAM_PROFILE = 'programprofile',
	PROGRAM_CRITERIA = 'programCriteria',
	GLOBAL_PROGRAM_CRITERIA = 'globalProgramCriteria',
	PROGRAM_APPLICABLE_FOR = 'programApplicableFor',
	GLOBAL_PROGRAM_APPLICABLE_FOR = 'globalProgramApplicableFor',
	ADD_REFERRAL = 'addreferrals',
	ADD_FEE_SCHEDULE = 'addfeeschedule',
	ADD_CONFERENCE = 'addconference',
	EDIT_CONFERENCE = 'editconference',
	CONFERENCE = 'conference',
	//GLOBAL CONFERENCE
	ADD_GLOBAL_CONFERENCE = 'addglobalconference',
	EDIT_GLOBAL_CONFERENCE = 'editglobalconference',
	EXPORT_CSV = 'exportcsv',
	SEND_MESSAGES = 'sendmessages',
	// Members
	ADD_MEMBER = 'addmember',
	GENERAL_INFORMATION = 'generalInformation',
	INSURANCE_INFO = 'insuranceInfo',
	PROVIDER_INFORMATION = 'providerInformation',
	ADD_LOCATION = 'addlocation',
	ADD_SCHEDULE = 'addschedule',
	ADD_POINT_OF_CONTACT = 'addpointofcontact',
	ADD_VITAL = 'addvital',
	GLOBAL_ADD_VITAL = 'globaladdvital',
	ADD_SESSION = 'addsession',
	Global_ADD_SESSION = 'globaladdsession',
	ADD_GOALS = 'addgoals',
	GLOBAL_ADD_GOALS = 'globaladdgoals',
	VIEW_CPT = 'viewcpt',
	EDIT_QUESTIONNARIE = 'editquestionnaire',
	ADD_JOURNAL = 'addjournal',
	ADD_CONDITION = 'addcondition',
	ADD_DEVICE = 'adddevice',
	ASSIGN_PROGRAM = 'assignprogram',
	VITAL_THRESHOLDS = 'vitalthresholds',
	CARE_TEAM = 'careteam',
	BOOKAPPTMENT = 'bookappointmentfor',
	ASSIGNPROGRAM = 'assignprogram',
	MEMBER_REFERRAL = 'referral',
	MEMBER_CARETEAM = 'careteam',
	ADD_GROUP = 'Add Group',
	CREATE_NEW_GROUP = 'createnewgroup',
	CREATE_TEMPLATE = 'createtemplate',
	ASSIGN_TEMPLATE = 'assigntemplate',
	ADD_GLOBAL_PROGRAM = 'addglobalprogram',
	GLOBAL_ADD_PROGRAM = 'Add Global Program',
	ADD_GLOBLE_SESSIONS = 'Add Session',
	ADD_SCREENING = 'Create Screening',
	ADD_QUESTION = 'addquestion',
	ASSIGN_GLOBAL_PROGRAM = 'assignglobalprogram',
	ADD_GLOBAL_SESSION = 'addglobalsession',
	ASSIGN_GLOBAL_SESSION = 'assignglobalsession',
	ASSIGN_MODULE_TO_PROGRAM = 'assignmoduletoprogram',
	ADD_SESSIONS = 'addsession',
	CHAT_SELECT = 'select',
	ASSIGNS_SCREENING = 'assignscreening',
	SCREENING_INFORMATION = 'screeninginformation',
	SCREENING_TILES = 'screeningtiles',
	SCORING_NON_SCORING = 'scoringnonscoring',
	MEMBER_LIST = 'memberlist',
	SESSION = 'session',
	ADDQUESTION = 'addquestion',
	SCREENING_LIBRARY = 'screening-library',
	// epi  dashboard
	LEAST_PERFORMING_PARTNERS = 'leastperformingpartners',
	TOP_COMPLETE_MDES = 'topcompletedmdes',
	LEAST_IN_COMPLETE_MDES = 'leastincompletemdes',
	LEAST_MEMBERS_WITH_INCOMPLETE_MDE = 'leastmemberswithincompletemde',
	//
	ADD_VITALS = 'addvitals',
	EXPORT_PDF = 'exportpdf',
	EXPORT_VITALS = 'exportvitals',
	STATISTICS = 'statistics',
	VITAL_READING = 'vitalreadings',
	VITAL_WIDGETS = 'vitalwidgets',
	ADD_NOTE = 'addNote',
	//  ADMIN DASHBOARD SECTIONS
	GOALS = 'goals', // also used in PM DASHBOARD SECTIONS
	ALERTS = 'alerts',
	CLAIMS = 'claims',
	MDE_ANALYSIS = 'mdeanalysis', // also used in PM DASHBOARD SECTIONS
	STAR_PARTNERS = 'starpartners', // also used in PM DASHBOARD SECTIONS
	//  PM DASHBOARD SECTIONS
	DEMOGRAPHIC_DETAILS = 'demographicdetails',
	SESSIONS = 'sessions',
	PM_DASHBOARD_TILES = 'pmdashboardtiles',
	//  Admin dashboard tiles
	TOTAL_MEMBERS = 'totalmembers',
	TOTAL_REFERRALS = 'totalreferrals',
	TOTAL_SESSIONS = 'totalsessions',
	ALL_PROGRAM = 'allprograms',
	ADMIN_DASHBOARD_TILES = 'admindashboardtiles',
	//  Epi dashboard
	EPI_MDE_TILES = 'epimdetiles',
	//  Provider (Member screen) dashboard
	PROVIDER_DASHBOARD = 'providerdashboard',
	//  Task Module Sections
	ASSIGNED_BY_ME = 'assignedbyme',
	ASSIGNED_TO_ME = 'assignedtome',
	ASSIGN_TASKS = 'assigntasks',
	CREATE_TASKS = 'createtasks',
	TASK_LIBRARY = 'tasklibrary',
	TASK_TRACKING = 'tasktracking',
	TASK_STATUS = 'taskstatus',
	CALL_TRACKING = 'calltracking',
	CALL_LISTING = 'callslisting',
	TASK_FOLLOWUPS = 'taskfollowups',
	TASK_TILES = 'tasktiles',
	TASK_DETAILS = 'taskdetails',
	FOLLOWUPS = 'followups',
	NOTES = 'notes',
	START_TASK = 'starttask',
	TASK_CALENDAR_WIDGET = 'taskcalendarwidget',
	TASK_CPTS_GRID = 'taskdetailscptgrid',
	CALL_DETAIL = 'calldetail',
	EXPORT_MEMBERS = 'exportmembers',
	ADD_ASSIGNEE = 'addassignee',
	ASSIGNEE = 'assignee',
	EDIT_ASSIGNEE = 'editassignee',
}
// Permission used
export enum PERMISSION_NAME {
	ADD = 'add',
	EDIT = 'edit',
	DELETE = 'delete',
	CLONE = 'clone',
	ASSIGN = 'assign',
	EXPORT_PDF = 'exportpdf',
	EXPORT_EXCEL = 'exportexcel',
	EXPORT_VITAL = 'exportvital',
	EXPORT_MEMBER = 'exportmember',
	EXPORT_CSV = 'exportcsv',
	SEND_MESSAGES = 'sendmessages',
	BOOKAPPMT = 'bookappointment',
	ASSIGN_GRID = 'assigngrid',
	FILTER = 'filter',
}

//table count detail
export enum PAGINATION_LABEL {
	SEARCHED_CLIENTS = 'Searched Clients',
	SEARCHED_PROVIDERS = 'Searched Providers',
	SEARCHED_PARTNERS = 'Searched Partners',
	SEARCHED_REFERALS = 'Searched Referrals',
	SEARCHED_PROGRAMS = 'Searched Programs',
	SEARCHED_MEMBERS = 'Searched Members',
	SEARCHED_HOSTS = 'Searched Hosts',
	SEARCHED_CLAIMS = 'Searched Claims',
	SEARCHED_GROUPS = 'Searched Groups',
	SEARCHED_SUMMARY_REPORT = 'Searched SummaryReport',
	SEARCHED_GLOBAL_PROGRAM = 'Searched Global Program',
	SEARCHED_ALERT = 'Searched Alert',
	SEARCHED_JOURNAL_NOTES = 'Searched Journal Notes',
	SEARCHED_DEVICE = 'Searched Devices',
	SEARCHED_CONDITION = 'Searched Conditions',
	SEARCHED_TASK = 'Searched Task',
	SEARCHED_SCREENING = 'Searched Screening',
	SEARCHED_GLOBAL_SESSIONS = 'Searched Global Sessions',
	SCREENING = 'Screening',
	CLIENTS = 'Clients',
	PROVIDERS = 'Providers',
	PARTNERS = 'Partners',
	REFERALS = 'Referrals',
	PROGRAMS = 'Programs',
	MEMBERS = 'Members',
	CLAIMS = 'Claims',
	GROUPS = 'Groups',
	CONFERENCE = 'Conference',
	SUMMARY_REPORT = 'Summary Report',
	GLOBAL_PROGRAMS = 'Global Programs',
	ALERTS = 'Alerts',
	JOURNAL_NOTES = 'Journal Notes',
	DEVICES = 'Devices',
	CONDITIONS = 'Conditions',
	TASKS = 'Task',
	SMBP_REPORTS = 'Reports',
	SEARCHED_SESSIONS = 'Searched Sessions',
	SESSIONS = 'Sessions',
	GLOBAL_SESSIONS = 'Global Sessions',
	AUDITS = 'Audits',
	SEARCHED_AUDITS = 'Searched Audits',
	POINT_OF_CONTACTS = 'Point Of Contacts',
	SEARCHED_POINT_OF_CONTACTS = 'Searched Point Of Contacts',
	GOALS = 'Goals',
	SEARCHED_GOALS = 'Searched Goals',
	CALL_LISTING = 'Calls',
	SEARCHED_CALL_LISTING = 'Searched Calls',
	LICENSE = 'License',
	SEARCHED_PROGRAM_APPLICATIONS = 'Searched Applications',
	PROGRAM_APPLICATIONS = 'Applications',
	UPLOAD_MEMBER_FILES = 'Files',
	SEARCH_CONFERENCE = 'Searched Conference',
	HOSTS = 'External Hosts',
	EXTERNAL = 'external',
	PATIENT = 'patient',
	PROVIDER = 'provider',
	RESULTS = 'Results',
	TOTAL_SCHEDULE = 'Schedules',
}

export enum LOCAL_STORAGE {
	PERMISSION_DETAIL = 'permissionDetail',
	SERVICE_NAME = 'serviceName',
	TOKEN = 'token',
	INHERITED_LOGIN = 'InheritedLogin',
	PROVIDER_SERVICES_DETAIL = 'providerServicesDetail',
	INTERNAL_HOST_DETAILS = 'internalHostDetails',
	CONFERENCE_DETAILS = 'conferenceDetails',
	AUTO_REFRESH_TOKEN = 'AuthRefreshToken',
	LAST_ACTIVITY = 'lastActivity',
	TERMS_AND_CONDITIONS = 'termsAndConditions',
	IS_OVER = 'isOver',
	USER_CONFIG = 'userConfig',
}
export enum EVENT_NAME {
	UPDATE_ROUTES = 'updateRoutes',
	ONLINE = 'online',
	OFFLINE = 'offline',
	RESIZE = 'resize',
	BEFORE_UNLOAD = 'beforeunload',
	CONNECT = 'connect',
	CONNECT_ERROR = 'connect_error',
	DISCONNECT = 'disconnect',
	UNLOAD = 'unload',
	STORAGE = 'storage',
}

export enum SERVICE_NAME {
	DASHBOARD = 'DASHBOARD',
	AWV = 'AWV',
	CCM = 'CCM',
	MTM = 'MTM',
	WELLNESS = 'WELLNESS',
	PUBLIC_HEALTH = 'PUBLIC HEALTH',
}
export enum FILE_UPLOAD_MESSAGES {
	SUCCESS = 'File Uploaded Successfully',
	ERROR = 'Something went wrong',
	DELETE = 'File deleted successfully',
}

export enum DROPDOWN_LIMIT {
	LIMIT = 10,
	MAX_LIMIT = 50,
	GROUP_LIMIT = 30,
}
export enum DEFAULT_ROUTE {
	MEMBERS = '/members',
}
export enum MEMBER_DROPDOWN_LIMIT {
	LIMIT = 100,
}
export enum DROPDOWN_PAGE {
	PAGE = 1,
}

export enum SOCKET_PORT {
	PORT = 3010,
}
export enum DEFAULT_CLIENT {
	CLIENT_NAME = 'carehalowest',
}
export enum DATE_FORMAT {
	DDD_MMM_D_YYYY = 'ddd, MMM D, YYYY',
	MMMM = 'MMMM',
	YYYY_MM_DDTHH_MM_SS = 'YYYY-MM-DDTHH:mm:ss',
}
export enum ACTIVITY_ACTION_NAME {
	PAGE_VISIT = 'page_visit',
	BUTTON_CLICK = 'button_click',
	FILTER_SECTION_ACTIVITY = 'filter_section_activity',
}

export enum DOWNLOAD_FILE_NAME {
	TASK_REPORT_PDF = 'task-report.pdf',
	TASK_REPORT_XLSX = 'task_report.xlsx',
	PATIENTS_VITALS = 'patients-vitals.pdf',
	SESSIONS_PDF = 'sessions.pdf',
	BILLING_REPORT_SVG = 'billing-report.xlsx',
}

export enum WV_DOH {
	TITLE = 'WV DH',
	ID = 'd28dec5d-1241-4a4a-b5d0-c7e820f34266',
}

export enum SOCIAL_IMAGE_URLS {
	PLAY_STORE = 'data:image/jpeg;base64,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',
	QR_CODE = 'https://carehalo.blob.core.windows.net/uploads/1737029813996carehalo_qr.webp',
	APP_STORE = 'data:image/png;base64,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',
	CAREHALO_DESCRIPTION = 'myCareHalo is a medical software app used for remote patient monitoring. Membership requires enrollment into the program through your health plan or health care provider. Please contact your health care provider to request an account. This application supports reading collected data from myCareHalo provided connected Bluetooth devicesu',
}

export enum SVG_STEPPER_CLASSNAMES {
	ACTIVE_CLASS = "flex md:w-full items-center text-fountainBlue dark:text-blue-500 sm:after:content-[''] lg:after:w-full lg:after:h-1 lg:after:border-b lg:after:border-gray-300 lg:after:border-1 after:hidden lg:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700",
	INACTIVE_CLASS = "flex md:w-full items-center after:content-[''] lg:after:w-full lg:after:h-1 lg:after:border-b lg:after:border-gray-300 lg:after:border-1 after:hidden lg:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700",
}
